import React from 'react';

const FilesModal = ({ isOpen, onClose, filesData }) => {
    if (!isOpen || !filesData || !filesData.files) {
        return null;
    }

    const { files } = filesData;

    const handleFileClick = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const truncateUrl = (url, maxLength = 100) => {
        if (!url) return '';
        if (url.length <= maxLength) return url;
        return url.substring(0, maxLength) + '...';
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return 'Unknown';
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        if (bytes === 0) return '0 Bytes';
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(7, 7, 10, 0.92)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '24px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1200px',
                    maxHeight: '860px',
                    backgroundColor: '#121212',
                    borderRadius: '10px',
                    boxShadow: '0 18px 60px rgba(0, 0, 0, 0.55)',
                    border: '1px solid rgba(100, 181, 246, 0.35)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        backgroundColor: 'rgba(220, 53, 69, 0.92)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '42px',
                        height: '42px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 8px 20px rgba(220, 53, 69, 0.45)',
                        transition: 'transform 0.2s ease, background-color 0.2s ease',
                        zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'rgba(207, 46, 60, 0.95)';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.92)';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        backgroundColor: '#0c0c0c',
                        padding: '24px'
                    }}
                >
                    <h3
                        style={{
                            margin: '0 0 24px 0',
                            color: '#e0e0e0',
                            fontWeight: '600'
                        }}
                    >
                        File Details
                    </h3>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {files.map((file, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: '#181818',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(100, 181, 246, 0.12)',
                                    padding: '20px'
                                }}
                            >
                                <div style={{ marginBottom: '16px' }}>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#9a9a9a',
                                        marginBottom: '12px',
                                        fontWeight: '600',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        File {index + 1}
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        gap: '20px',
                                        flexWrap: 'wrap',
                                        alignItems: 'flex-start'
                                    }}>
                                        <div style={{ flex: 1, minWidth: '300px' }}>
                                            <div style={{ marginBottom: '12px' }}>
                                                <a
                                                    href={file.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title={file.url}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleFileClick(file.url);
                                                    }}
                                                    style={{
                                                        color: '#60a5fa',
                                                        textDecoration: 'none',
                                                        fontSize: '14px',
                                                        display: 'block',
                                                        marginBottom: '8px',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        cursor: 'pointer'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.textDecoration = 'underline';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.textDecoration = 'none';
                                                    }}
                                                >
                                                    {truncateUrl(file.url, 150)}
                                                </a>
                                                <div style={{
                                                    display: 'flex',
                                                    gap: '15px',
                                                    flexWrap: 'wrap',
                                                    fontSize: '12px',
                                                    color: '#a0a0a0'
                                                }}>
                                                    {file.category && (
                                                        <span>
                                                            <strong>Category:</strong> {file.category}
                                                        </span>
                                                    )}
                                                    {file.type && (
                                                        <span>
                                                            <strong>Type:</strong> {file.type}
                                                        </span>
                                                    )}
                                                    {file.size && (
                                                        <span>
                                                            <strong>Size:</strong> {formatFileSize(file.size)}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            {file.pages && file.pages.length > 0 && (
                                                <div>
                                                    <div style={{
                                                        fontSize: '11px',
                                                        color: '#888',
                                                        textTransform: 'uppercase',
                                                        marginBottom: '10px',
                                                        fontWeight: '600',
                                                        letterSpacing: '0.5px'
                                                    }}>
                                                        Used on {file.pages.length} page{file.pages.length !== 1 ? 's' : ''}
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                        {file.pages.map((page, pageIndex) => (
                                                            <a
                                                                key={pageIndex}
                                                                href={page.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                title={page.url}
                                                                style={{
                                                                    color: '#9ca3af',
                                                                    textDecoration: 'none',
                                                                    fontSize: '12px',
                                                                    padding: '8px 12px',
                                                                    backgroundColor: '#1f1f1f',
                                                                    borderRadius: '4px',
                                                                    border: '1px solid #2a2a2a',
                                                                    transition: 'all 0.2s ease',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    display: 'block'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.backgroundColor = '#262626';
                                                                    e.target.style.textDecoration = 'underline';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.backgroundColor = '#1f1f1f';
                                                                    e.target.style.textDecoration = 'none';
                                                                }}
                                                            >
                                                                {truncateUrl(page.url, 120)}
                                                            </a>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilesModal;

